export default __webpack_public_path__ + "static/christoph-nakazawa-f88b807ea8b35bd802167e3c12da88d6.jpg";